initMarquee('.Index_object_instagram_marquee', {
    mobile: {
        duration: 80000,
        gap: 0,
        duplicated: true,
        direction: "left"
    },
    desktop: {
        duration: 80000,
        gap: 0,
        duplicated: true,
        direction: "left"
    }
});